import { Element } from '@zmedia/bm-soccer-ui/components';
import { memo } from 'react';
import { IRankingTeam } from '@zmedia/bm-soccer-ui/interface';
import { TableFooter, TableHeader, TableRow } from '..';
import styles from '../style.module.scss';

function Table(props: any) {
    const {
        home,
        away,
        items = [],
        promotions = [],
        teamIdSelect,
        itemSizeLimit,
        children
    } = props;

    const hasMatchRecent =
        items.filter((item: IRankingTeam) => {
            return item?.mr?.length > 0;
        }).length > 0;

    const renderList = () => {
        return items
            .slice(0, itemSizeLimit)
            .map((item: IRankingTeam, index: number) => {
                let color = item?.promotion?.color || '';
                return (
                    <TableRow
                        key={index}
                        item={item}
                        color={color}
                        home={home}
                        away={away}
                        teamIdSelect={teamIdSelect}
                        hasMatchRecent={hasMatchRecent}
                    />
                );
            });
    };

    if (!items.length) {
        return null;
    }

    return (
        <Element className={styles['table-ranking']}>
            <TableHeader hasMatchRecent={hasMatchRecent} />
            <Element className={styles['tbody']}>{renderList()}</Element>
            <TableFooter promotions={promotions} />
            {children}
        </Element>
    );
}

export default memo(Table);
